import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  Output,
} from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ErrorHandlingService } from 'src/app/core/services/error-handling.service';
import { HttpService } from 'src/app/core/services/api/http.service';

@Component({
  selector: 'app-custom-field-form',
  templateUrl: './custom-field-form.component.html',
  styleUrls: ['./custom-field-form.component.css'],
})
export class CustomFieldFormComponent implements OnInit, OnChanges {
  @Input() isRequired: boolean = false;
  @Input() form!: FormGroup;
  @Input('module') moduleName: any;
  @Input() data?: any;

  @Output() customFieldsExists = new EventEmitter<boolean>();

  isLoading: boolean = false;
  isDataSet: boolean = false;
  customFields: any[] = [];

  constructor(
    private _api: HttpService,
    private errHandle: ErrorHandlingService
  ) {}

  ngOnInit(): void {
    this.getAllCustomField();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.data?.length && !this.isDataSet) {
      this.isDataSet = true;
      this.setData();
    }
  }

  getAllCustomField() {
    this.isLoading = true;
    this._api
      .getReq(
        `/custom-field?filter_by_type=${this.moduleName}&filter_by_active=true`
      )
      .subscribe(
        (res) => {
          this.customFields = res?.data;
          this.customFieldsExists.emit(!!this.customFields?.length);
          this.setData();
          this.isLoading = false;
        },
        (err) => {
          this.customFields = [];
          this.errHandle.errorHandling(err);
          this.isLoading = false;
        }
      );
  }

  setData() {
    this.resetFormArray();
    this.customFields.forEach((data: any) => {
      this.pushFieldToFormArray(data);
    });
    if (this.data) {
      this.setDataInFormArray(this.data);
    }
  }

  resetFormArray() {
    const itemsArray = this.form.get('customFieldsArr') as FormArray;
    itemsArray.clear(); // This will remove all controls from the FormArray
  }

  pushFieldToFormArray(customField: any) {
    const formArr = this.form.get('customFieldsArr') as FormArray;
    formArr.push(
      new FormGroup({
        id: new FormControl(customField?.id, []),
        fieldName: new FormControl(
          customField?.name || 'unknown field name',
          []
        ),
        fieldDesc: new FormControl(customField?.description, []),
        content: new FormControl('', []),
        help_text: new FormControl(customField?.help_text, []),
        help_text_active: new FormControl(!!customField?.help_text_active, []),
      })
    );
  }

  //to handling looping on form arrays in html
  getFormsArray(form: any) {
    return form?.controls;
  }

  fetchFormArrayData() {
    const formArray = this.form.get('customFieldsArr') as FormArray;

    let custom_fields: any[] = [];
    formArray.controls.forEach((formGroup: any) => {
      if (formGroup.controls['content'].value) {
        custom_fields.push({
          attribute_id: formGroup.controls['id'].value,
          value: formGroup.controls['content'].value,
        });
      }
    });

    return custom_fields;
  }

  setDataInFormArray(data?: any) {
    if (!data) {
      return;
    }
    const formArray = this.form.get('customFieldsArr') as FormArray;
    formArray.controls.forEach((formGroup: FormGroup | any) => {
      for (let i = 0; i < data.length; i++) {
        if (
          data[i].id == formGroup.controls['id'].value ||
          data[i].attribute_id == formGroup.controls['id'].value
        ) {
          formGroup.patchValue({
            content: data[i].value,
          });
        }
      }
    });
  }
}
